export const weightUnits =  [
    { unit: 'kg', name: 'kg'},
    { unit: 'gramms', name: 'gramms'},
    { unit: 'kg/day', name: 'kg/day'},
]

export const milkUnits =  [
    { unit: 'g/dl', name: 'g/dL'},
    { unit: 'mg/dl', name: 'mg/dL'},
    { unit: 'mmHg', name: 'mmHg'},
    { unit: '%', name: '%'},
    { unit: 'days', name: 'days'},
    { unit: 'count/ml', name: "count/ml"}
]

export const birthEaseTypes = [
    { text: 'No Assistance', value: 'No Assistance'},
    { text: 'Some Assistance', value: 'Some Assistance'},
    { text: 'Mechanical Assistance', value: 'Mechanical Assistance'},
    { text: 'A Cesarean section', value: 'A Cesarean section'},
    { text: 'Abnormal Delivery', value: 'Abnormal Delivery'},
]

export const totalLongevity = [
    { text: 'Removed from herd between 1 to 5 years', value: 0},
    { text: 'Stayed in a herd for all 5 years', value: 1}
]

export const timeUnits = [
    { text: 'days', value: 'days'},
    { text: 'weeks', value: 'weeks'},
    { text: 'months', value: 'months'},
    { text: 'years', value: 'years'}
]

export const conceptionMethod = [
    { text: 'Natural Mating', value: 'Natural Mating'},
    { text: 'Artificial Insemination', value: 'Artificial Insemination'},
    { text: 'Embryo Transfer', value: 'Embryo Transfer'},
]

// export const breeds = [
//     "Angus",
//     "Bonsmara",
//     "Brahman",
//     "Holstein-Friesian",
//     "Jersey",
//     "Kyoga",
//     "Kigezi",
//     "Nkedi",
//     "Naganda",
//     "Nagpuri",
//     "Nyoro",
//     "Murrah",
//     "Simmental"
// ]

export const animalRemovalReasons= [
    {
      text: "Sale",
      value: "Sale",
    },
    {
      text: "Slaughter",
      value: "Slaughter",
    },
    {
      text: "Death",
      value: "Death",
    },
    {
      text: "Theft",
      value: "Theft",
    },
    {
      text: "Other",
      value: "Other",
    },
]

export const breeds = [
  { header: 'Cattle breeds' },
    'Angus',
    'Bonsmara',
    'Banteng',
    'Brahman',
    'Holstein-Friesian',
    'Jersey',
    'Kyoga',
    "Kigezi",
    "Nkedi",
    "Naganda",
    "Nyoro",
    "Simmental",
    'Bali cattle/Balinese cattle',
    'Sumba Ongole',
    'Ongole Grade',
    'Madura',
    'Pasundan',
    'Pesisir cattle',
    'Aceh cattle',
    'Galekan cattle',
    'Jabres cattle',
    'Rancah cattle',
    'Rambon cattle',
    'Javanese cattle',
    'Limousin',
    'Simmental Purebred',
    'Simmental Crossbred',
    'Holstein Friesian',
    'Mixed Breed',
    'Non descriptive',
  { divider: true },
  { header: 'Buffalo breeds' },
    'Kalang',
    'Pampangan buffalo',
    'Simelue buffalo',
    'Moa buffalo',
    'Sumbawa buffalo',
    'Toraya buffalo',
    'South Kalimantan buffalo',
    'East Kalimantan buffalo',
    'Mixed Breed',
    'Non descriptive',
    "Nagpuri",
    "Murrah",
  { divider: true },
  { header: 'Other' },
    'Other',
]
